import { BASE_ENDPOINT } from "../../endpoint";

export const updatePlanFeaturesService = async (TOKEN, planId, planInfo) => {
  try {
    const payload = Array.isArray(planInfo) ? { features: planInfo } : planInfo;

    const response = await fetch(
      `${BASE_ENDPOINT}/api/payrollplans/${planId}/features`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
    const res = await response.json();
    if (!response.ok) {
      console.error("Error:", res);
      throw new Error(res.message || "Failed to update plan");
    }
    return res;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
